'use strict';

var keyMirror = require('keymirror');

module.exports = {
	ActionTypes: keyMirror({
		COURSE_SEARCH_LOAD_DATA: null,
		COURSE_SEARCH_LOAD_DATA_SUCCESS: null,
		COURSE_SEARCH_LOAD_DATA_ERROR: null,
		COURSE_SEARCH_UPDATE_FILTERS: null,
		COURSE_SEARCH_SUBMIT_FORM: null,
		COURSE_SEARCH_CLEAR_FILTERS: null
	})
};